"use client";

import * as React from "react";
export default function About() {
  return null;
}